/**
 * Keeps a half-finished sign-up (step, what was typed, the emailed code) across
 * a page reload, in this browser tab only (`sessionStorage`): a reload used to
 * throw everything away, and on the password step it even left the person
 * registered without knowing. Native has no sessionStorage: every call is a no-op.
 */
const PREFIX = 'kt:join-draft:'

const storage = (): Storage | null => {
  try {
    return (globalThis as { sessionStorage?: Storage }).sessionStorage ?? null
  } catch {
    return null
  }
}

export function loadJoinDraft<T>(key: string): T | null {
  try {
    const raw = storage()?.getItem(PREFIX + key)
    return raw ? (JSON.parse(raw) as T) : null
  } catch {
    return null
  }
}

export function saveJoinDraft(key: string, value: unknown): void {
  try {
    storage()?.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // Private mode / quota: the draft is a convenience, never an error.
  }
}

export function clearJoinDraft(key: string): void {
  try {
    storage()?.removeItem(PREFIX + key)
  } catch {
    // Nothing to clear.
  }
}
